var _rect, _g, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.500061,
    width: 33,
    height: 33,
    rx: 16.5,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1082_21720)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00275 24.6508C8.00275 24.779 8.01471 24.9221 8.06558 25.0443C8.25707 25.5213 8.83154 25.6167 9.22349 25.2262C10.1779 24.2842 11.1264 23.3362 12.0689 22.3853C12.2125 22.2422 12.3561 22.1796 12.5626 22.1855C14.5762 22.1885 16.5898 22.1885 18.6065 22.1885C20.7009 22.1885 22.8013 22.1885 24.8957 22.1885C24.9765 22.1885 25.0603 22.1885 25.141 22.1796C25.6078 22.1378 25.9818 21.792 25.9908 21.327C26.0057 20.8083 26.0117 20.2836 25.9369 19.7679C25.7365 18.3758 25.0872 17.2132 23.9891 16.3219C22.7175 15.2904 21.2544 14.9118 19.6417 15.1533C18.6573 15.2994 17.7837 15.7167 16.9998 16.3576C16.925 16.301 16.8651 16.2563 16.8083 16.2116C15.5636 15.2725 14.1573 14.9178 12.6224 15.1503C11.276 15.35 10.157 15.9999 9.28034 17.0403C8.55328 17.9048 8.08951 18.9064 8.04463 20.0303C7.97582 21.5714 8.00873 23.1126 8.00275 24.6508Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4874 14.2173C15.0403 14.2143 16.3298 12.9265 16.3298 11.3734C16.3298 9.81134 15.0373 8.52354 13.4694 8.5295C11.9106 8.53248 10.627 9.82029 10.624 11.3734C10.621 12.9325 11.9196 14.2233 13.4874 14.2173Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6355 14.2173C22.2033 14.2203 23.4958 12.9325 23.4958 11.3674C23.4958 9.81728 22.2063 8.53246 20.6504 8.52649C19.0826 8.52351 17.79 9.81132 17.79 11.3764C17.793 12.9265 19.0766 14.2143 20.6355 14.2173Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9504 21.2674C18.9504 21.2674 18.9504 21.175 18.9504 20.379C18.9504 18.6948 18.1456 17.5024 17.4843 16.8048C17.3048 16.617 17.1373 16.465 16.9996 16.3487C16.859 16.465 16.6915 16.617 16.5149 16.8048C15.8537 17.5024 15.0488 18.6948 15.0488 20.379C15.0488 21.175 15.0488 21.2674 15.0488 21.2674C15.0488 21.2674 15.0339 22.1915 16.0542 22.1915C16.2816 22.1915 16.4701 22.1915 16.6286 22.1915C17.3108 22.1915 17.3736 22.1915 17.3736 22.1915C17.5292 22.1915 17.7177 22.1915 17.9481 22.1915C18.9534 22.1915 18.9504 21.2674 18.9504 21.2674Z",
    fill: "#1967D2"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.500061,
    width: 33,
    height: 33,
    rx: 16.5,
    stroke: "#E9E9E9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1082_21720"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 16.9412,
    fill: "white",
    transform: "translate(8 8.52948)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleGroup);
export default __webpack_public_path__ + "static/media/google-group.aa0701f163c8c84bda0389953ef2b30d.svg";
export { ForwardRef as ReactComponent };